export const logIn = {
  username: "Username",
  password: "Password",
  signIn: "Sign In",
  forgotPassword: "Forgot password?",
  send: "Send",
  submit: "Submit",
  scanQrWithAppMessage: "Please use an Authenticator app to scan the QR to get access code",
  inputTotp: "กรุณาใส่รหัสผ่าน 6 หลัก จากแอพ Google Authenticator",
  totpCode: "GOOGLE AUTHENTICATOR CODE (6 หลัก)",
  inputSmsOtp: "กรุณาใส่รหัสผ่าน 4 หลัก จาก SMS",
  otp: "SMS OTP (4 หลัก)"
};
